module.exports = __webpack_public_path__ + "static/media/vouch1.c04f03dc.png";